









import { Vue, Component, Prop } from "vue-property-decorator";
import { ICustomStylingClass } from "@/components/Globals/types/custom.t";
import CustomText from '@/components/Globals/CustomText.vue';
import CustomImage from '@/components/Globals/CustomImage.vue';

@Component({
  components: {
    CustomText,
    CustomImage
  }
})
export default class TabIcon extends Vue {
  @Prop()
  customClass?: ICustomStylingClass[];

  @Prop()
  icon!: string;

  @Prop()
  useImgIcon?: boolean;

  get customsAssets() {
    return `${this.$store.state.endPoints.customizer.customsAssets}/svg/customizer/`;
  }
}
